// import moment from 'moment';
import moment from 'moment-timezone';

// export const dateConverter = (data, type) => {
//     let setedDate = new Date(data?.startDate.slice(0, 22));
//     data?.startTime && setedDate.setHours(data?.startTime.slice(0, 2), data?.startTime.slice(3, 5));
//     let tzDifference = data?.timezoneOffset + new Date().getTimezoneOffset() / 60;
//     let localTime = moment(setedDate)
//         .add(moment.duration(-tzDifference, 'hours'))
//         .format(type ? type : 'llll');
//     return localTime;
// };



export const dateConverter = (data, type) => {
    if (!data?.startDate) return 'Invalid date';

    // Create base date
    const date = new Date(data.startDate.slice(0, 22));

    if (data.startTime) {
        const hours = parseInt(data.startTime.slice(0, 2), 10);
        const minutes = parseInt(data.startTime.slice(3, 5), 10);
        date.setHours(hours, minutes);
    }
    const offset = typeof data.timezoneOffset === 'number' ? data.timezoneOffset : 0;
    const localOffset = new Date().getTimezoneOffset() / 60; // in hours
    const tzDifference = offset + localOffset;
    const adjustedTime = moment(date).add(-tzDifference, 'hours');
    return adjustedTime.format(type || 'llll');
};
export const originalDateConverter = (data) => {
    let setedDate = new Date(data?.startDate.slice(0, 22));
    data?.startTime && setedDate.setHours(data?.startTime.slice(0, 2), data?.startTime.slice(3, 5));
    let localTime = moment(setedDate).format('llll');
    return localTime;
};

export const multiConverter = (date, time, tz, type) => {
    let setedDate = new Date(date?.slice(0, 22));
    time && setedDate.setHours(time.slice(0, 2), time.slice(3, 5));
    let tzDifference = tz + new Date().getTimezoneOffset() / 60;
    let localTime = moment(setedDate)
        .add(moment.duration(-tzDifference, 'hours'))
        .format(type ? type : 'hh A');
    return localTime;
};

export const startEndTime = (it) => {
    return moment(`Mon 03-Jul-2017, ${it}`, 'ddd DD-MMM-YYYY, hh:mm A').format('hh:mm A');
};
